import React from 'react';
import PropTypes from 'prop-types';
import Reflux from 'reflux';
import ArchiveLicenseActions from 'ArchiveLicenseActions';
import ArchiveLicenseStore from 'ArchiveLicenseStore';
import ArchiveLicenseStatus from './ArchiveLicenseStatus';

const ArchiveLicenseStatusContainer = React.createClass({
  propTypes: {
    summary: PropTypes.bool,
  },

  mixins: [Reflux.connect(ArchiveLicenseStore, 'licenseStatus')],

  componentDidMount() {
    ArchiveLicenseActions.getLicenseStatus();
  },

  render() {
    if (this.state.licenseStatus.loading) {
      return null;
    }

    return <ArchiveLicenseStatus licenseStatus={this.state.licenseStatus} summary={this.props.summary} />;
  },
});

export default ArchiveLicenseStatusContainer;



// WEBPACK FOOTER //
// ./src/web/components/ArchiveLicenseStatusContainer.jsx